module.exports = __webpack_public_path__ + "img/reload-red.64bc14e1.svg";